import React from 'react'
import PropTypes from 'prop-types'

import {Link} from 'gatsby'
import {useCurrentLocation} from '../utils/CurrentLocation'

const isBrowser = typeof window !== 'undefined' && window

if (isBrowser) {
	// eslint-disable-next-line global-require
	require('smooth-scroll')('a[href*="#"]', {
		offset: function () {
			return document.getElementById('navbar').clientHeight
		},
	})
}

const SmartLink = ({to, children, ...rest}) => {
	const currentLocation = useCurrentLocation()
	if (to.startsWith('#')) {
		const newTo = `${currentLocation}${to}`
		return <SmartLink to={newTo} children={children} {...rest}/>
	}

	if (!to || rest.target === '_blank') return <a rel="noopener noreferrer" href={to} {...rest}>{children}</a>

	// If the url starts with a https:// or http:// render normal anchor because it points out of the site
	if (to.match(/^https?:\/\//)) {
		return <a rel={rest.target === 'blank' ? 'noopener noreferrer' : ''} href={to} {...rest}>{children}</a>
	}

	return <Link partiallyActive to={to} {...rest}>{children}</Link>
}

SmartLink.propTypes = {
	target: PropTypes.string,
	to: PropTypes.string,
	children: PropTypes.node.isRequired,
}

SmartLink.defaultProps = {
	target: undefined,
	to: undefined,
}

export default SmartLink
